import { Field, InputType, Int } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class CreateCustomerPayrollIntegratedArgs extends ActionArgs {
  @Field(() => Int)
  number: number

  @Field(() => String)
  plantId: string
}
